<mat-form-field id="language-selector" class="m-l-10">
  <mat-label>{{ 'labels.inputs.Language' | translate }}</mat-label>
  <mat-select [formControl]="languageSelector" (selectionChange)="setLanguage()" class="languageselector">
    @for (language of languages; track language) {
      <mat-option [value]="language">
        {{ 'languages.' + language | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
